import { render, staticRenderFns } from "./datasource.vue?vue&type=template&id=141942fe&scoped=true&"
import script from "./datasource.vue?vue&type=script&lang=js&"
export * from "./datasource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141942fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('141942fe')) {
      api.createRecord('141942fe', component.options)
    } else {
      api.reload('141942fe', component.options)
    }
    module.hot.accept("./datasource.vue?vue&type=template&id=141942fe&scoped=true&", function () {
      api.rerender('141942fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gen/datasource.vue"
export default component.exports